import { chainCommands } from 'prosemirror-commands'
import type { Command } from 'prosemirror-state'

import { jumpToPage as jumpToPageLegacyInline } from './plugins/inlinePageBreaks'
import { jumpToPage as jumpToPageNewPaginator } from './plugins/pagination'

export function jumpToPage(pageIndex: number): Command {
  return chainCommands(
    jumpToPageNewPaginator(pageIndex),
    jumpToPageLegacyInline(pageIndex),
  )
}
